<div class="page-container">
    <app-loader *ngIf="isLoading"></app-loader>

    <div *ngIf="!isLoading" class="content-container">
        <confirm-modal></confirm-modal>

        <div class="action-buttons margin-bottom-15" *ngIf="request.cancelation_request == 0">
            <button mat-icon-button class="delete-button" title="Izbriši zahtjev" (click)="deleteRequest()">
                <mat-icon>delete</mat-icon>
                <span class="button-text">Poništi zahtjev</span>
            </button>
        </div>

        <div>
            <div class="info-section">
                <h2 class="doc-name">{{ request.doc_name }}</h2>
            </div>

            <div class="padding-top-20">
                <div class="date-section">
                    <h2>Period odmora od {{ request.date_from | date:'dd.MM.yyyy' }} do {{ request.date_to | date:'dd.MM.yyyy' }}</h2>
                </div>

                <div *ngIf="request.hours || request.minutes" class="absence-container">
                    <h2>Sati odsustva: {{ request.hours ? request.hours : 0}}</h2>
                    <h2>Minuti odsustva: {{ request.minutes ? request.minutes : 0 }}</h2>
                  </div>

                <div>
                    <h2>Zaposleni: {{userData.first_name}} {{userData.last_name}}</h2>
                </div>

                <div class="replacement-section">
                    <div class="info-and-button">
                        <h2 class="replacement-info">Zaposlenog mijenja: {{ replacement_employee }}</h2>
                        <button class="tooltip-button" title="Promijeni" (click)="changeReplacementEmployee()">
                            <i class="lni lni-reload"></i>
                        </button>
                    </div>

                    <div class="centered-content" *ngIf="showChangeEmployeeReplacementOption">
                        <div class="close-icon" (click)="close()">
                            <i class="lni lni-close"></i>
                        </div>
                        <form name="form" [formGroup]="form" class="flexify">
                            <app-choose-validators [ids]="validator.value" [myForm]="form" (outputToParent)="getValidatorIds($event)"></app-choose-validators>
                        
                            <button class="btn btn-sm save-button" (click)="saveChangedReplacementEmployee()" [disabled]="pending"> 
                                <span *ngIf="!pending"><i class="lni lni-checkmark"></i> &nbsp; Sačuvaj izmjene</span>
                                <span *ngIf="pending"><div class="loader"></div></span>
                            </button>
                        </form>
                    </div>

                </div>

                <div class="description-section" *ngIf="request.description">
                    <div>Opis: {{ request.description }}</div>
                </div>

                <div class="description-section margin-top-20" *ngIf="request.rejection_reason">
                    <div>Razlog odbijanja: {{ request.rejection_reason }}</div>
                </div>

                <div class="refusal-reason-section" *ngIf="creatorId ==request.manager_id || creatorId == 1">
                    <label>Razlog odbijanja zahtjeva: <span class="required">*</span></label>
                    <textarea class="form-control" [(ngModel)]="refusalReason" rows="4" [ngStyle]="{'border': showErrorBorder ? '1px solid red' : '1px solid #ced4da;'}"></textarea>
                </div>

                <div class="row refuse-button-section">
                    <div class="refuse-button-section" *ngIf="creatorId == request.manager_id || creatorId == 1">
                        <button class="btn btn-sm refuse-button" (click)="refuseRequest()" [disabled]="pendingRefusal">
                            <span *ngIf="!pendingRefusal"><i class="lni lni-cross-circle"></i> Odbij zahtjev</span>
                            <span *ngIf="pendingRefusal"><div class="loader-refusal"></div></span>
                        </button>
                    </div>
                    &nbsp; &nbsp;
                    <div class="refuse-button-section" *ngIf="creatorId == request.manager_id || creatorId == 1">
                        <button class="btn btn-sm btn-live-green" (click)="approveRequest()" [disabled]="pendingApproval">
                            <span *ngIf="!pendingApproval"><i class="lni lni-checkmark-circle"></i> Odobri zahtjev</span>
                            <span *ngIf="pendingApproval"><div class="loader-approve"></div></span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>